/**
 * Device/viewport dimensions attached to a form submission.
 *
 * Moved out of the rule engine's form-helpers: it reads `window`, so it cannot
 * live in a package meant to run outside a browser, and no engine function ever
 * called it — its only consumer is Form.jsx's submit payload. It is submission
 * telemetry, not form logic.
 *
 * Kept in the web app rather than becoming an injected seam. The two seams that
 * exist (translator, telemetry) are there because the *engine* needs those
 * capabilities; the engine has no use for this one at all, so the app simply
 * owns it.
 */
export const getDeviceInformation = () => {
    //Note: screen.orientation is not well supported by browsers
    //var screenOrientation = screen.orientation != null ? screen.orientation.type : null;

    const mql = window.matchMedia("(orientation: portrait)");

    // If there are matches, we're in portrait
    const screenOrientation = mql.matches ? "portrait" : "landscape";

    return {
        screenOrientation: screenOrientation,
        viewportHeight: window.innerHeight,
        viewportWidth: window.innerWidth,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
    };
};
